<template>
  <div v-loading="isLoading">
    <div class="h-print text-right mb-2">
      <el-button
        type="primary"
        size="small"
        :loading="isDownloading"
        :disabled="!table.data || !table.data.length"
        @click="downloadPdf"
      >
        Download PDF
      </el-button>
    </div>
    <!-- not jettainer -->
    <print-template
      ref="standardPrintTemplate"
      :viewExtraFooter="false"
      :viewFooter="false"
      :viewHeader="true"
      :viewSubheader="false"
      :download-only="true"
      download-file-name="repair-uld-out.pdf"
      v-if="!table.info.is_jettainer"
    >
      <div class="form-wrapper">
        <div class="form-head">
          <h3 class="text-center mt-5 mb-5">DELIVERY NOTE</h3>
          <el-button
            class="mb-2 mt-2 h-print"
            size="small"
            type="primary"
            v-if="!hideEditButton"
            @click="$refs.dialog.open()"
            >Edit Delivery Note Details</el-button
          >
          <app-dialog ref="dialog" cancelText="Close">
            <el-form>
              <el-form-item label="Company">
                <el-input v-model="reportData.company"></el-input>
              </el-form-item>
              <el-form-item label="Address">
                <el-input v-model="reportData.address"></el-input>
              </el-form-item>
              <el-form-item label="Attention">
                <el-input v-model="reportData.attention"></el-input>
              </el-form-item>
              <el-form-item label="Remarks">
                <el-input
                  type="textarea"
                  v-model="reportData.remarks"
                ></el-input>
              </el-form-item>
            </el-form>
          </app-dialog>
          <table class="mb-3 header-info-table">
            <colgroup>
              <col style="width: 65%" />
              <col style="width: 35%" />
            </colgroup>
            <tbody>
              <tr>
                <td class="header-info-left">
                  <div>
                    <span class="header-info-label">Company:</span>
                    <span>{{ reportData.company }}</span>
                  </div>
                  <div>
                    <span class="header-info-label">Address:</span>
                    <span>{{ reportData.address }}</span>
                  </div>
                  <div>
                    <span class="header-info-label">Attention:</span>
                    <span>{{ reportData.attention }}</span>
                  </div>
                </td>
                <td class="header-info-right">
                  <div>
                    <span class="header-info-label">Delivery Note No.:</span>
                    <span>{{ table.info.batch_no }}</span>
                  </div>
                  <div>
                    <span class="header-info-label">Date:</span>
                    <span>{{ table.info.delivery_date | dateFormat }}</span>
                  </div>
                  <div v-if="collectedReceiptNumbers">
                    <span class="header-info-label">Receipt No.:</span>
                    <span>{{ collectedReceiptNumbers }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table
            class="table table-bordered mb-2 detailed-table"
            v-if="shouldShowDetailedColumns"
          >
            <colgroup>
              <col style="width: 8%" />
              <col style="width: 44%" />
              <col style="width: 16%" />
              <col style="width: 17%" />
              <col style="width: 15%" />
            </colgroup>
            <thead>
              <tr style="border:1px solid black">
                <th>Item</th>
                <th>Description</th>
                <th>Part No.</th>
                <th>Serial No.</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in table.data" :key="item.id">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.part_no }}</td>
                <td>{{ item.tso_ser_no }}</td>
                <td style="border:1px solid black">{{ item.status }}</td>
              </tr>
            </tbody>
          </table>
          <table
            class="table table-bordered mb-2"
            v-else
          >
            <colgroup>
              <col
                v-for="i in 30"
                :key="`col-${i}`"
                style="width: calc(100% / 3)"
              />
            </colgroup>
            <thead>
              <tr>
                <th>Item No.</th>
                <th>TSO Serial No</th>
                <th>ULD ID CODE</th>
              </tr>
            </thead>
            <!-- v-for="i in 100" :key="i" -->
            <tbody>
              <tr v-for="(item, index) in table.data" :key="item.id">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.tso_ser_no }}</td>
                <td class="text-center">{{ item.uld_id_code }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-left">
        <label>Remarks:</label>
        <p style="min-height: 100px; margin-top: 0">
          {{ reportData.remarks }}
        </p>
        <p>
          I hereby acknowledge that I received the above-mentioned items in good
          condition.
        </p>
        <ul class="list-unstyled w-50">
          <li style="position: relative; margin-bottom: 15px">
            Received by:
            <label
              style="border-bottom: 1px solid #333; display: block; width: 250px; position: absolute; left: 100px; bottom: 3px "
            ></label>
          </li>
          <li style="position: relative">
            Date &amp; Time:
            <label
              style="border-bottom: 1px solid #333; display: block; width: 250px; position: absolute; left: 100px; bottom: 3px "
            ></label>
          </li>
        </ul>
      </div>
      <!-- <template v-slot:customFooter>
        <div class="text-left">
          <p>
            I hereby acknowledge that I received the above-mentioned items in
            good condition.
          </p>
          <ul class="list-unstyled">
            <li>Received by:</li>
            <li>Date &amp; Time:</li>
          </ul>
        </div>
      </template> -->
    </print-template>
    <!-- jettainer -->
    <print-template
      ref="jettainerPrintTemplate"
      :viewExtraFooter="false"
      :viewFooter="false"
      :viewHeader="false"
      :download-only="true"
      download-file-name="repair-uld-out.pdf"
      v-if="table.info.is_jettainer"
      class="jettainer-print"
    >
      <div class="form-wrapper-jettainer">
        <div class="form-head">
          <table class="table table-bordered">
            <tr>
              <td style="border-right: 0; text-align: center">
                <img src="/images/jettainer-logo.png" alt="jettainer-logo" />
              </td>
              <td style="border-left: 0; text-align: center">
                <h1 class="mb-0">DELIVERY NOTE</h1>
              </td>
              <td>
                DATE:
                <b>{{ info.delivery_date | dateFormat("DD-MMM YYYY") }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border-bottom: 0">
                2. Organization issuing this form:
              </td>
              <td>DELIVERY NOTE NUMBER</td>
            </tr>
            <tr>
              <td class="text-center" colspan="2" style="border-top: 0">
                <b>TOTAL EXPERTISE, LTD. - ABU DHABI, U.A.E</b>
              </td>
              <td class="text-center">
                <b>{{ info.batch_no }}</b>
              </td>
            </tr>
          </table>

          <table class="table table-bordered mt-2 mb-2">
            <thead>
              <tr>
                <th>4. Item</th>
                <th>5. Description</th>
                <th>6. Part No.</th>
                <th colspan="2">7. ULD ID Code - Serial</th>
                <th>8. Status</th>
              </tr>
            </thead>
            <!-- v-for="i in 100" :key="i" -->
            <tbody>
              <tr v-for="(item, index) in table.data" :key="item.id">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.part_no }}</td>
                <td>{{ item.uld_id_code }}</td>
                <td>{{ item.tso_ser_no }}</td>
                <td>{{ item.status }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-left" style="border: 2px solid #333; padding: 8px 12px">
        <table class="table">
          <tr>
            <td colspan="3">
              <p class="mb-2 mt-0">Received by:</p>
            </td>
          </tr>
          <tr>
            <td style="width:45%">Signature: _________________________</td>
            <td style="width:23%">Date: ___________</td>
            <td>
              <img src="/images/jettainer-logo.png" alt="jettainer-logo" />
            </td>
          </tr>
          <tr>
            <td colspan="2">Printed Name: _____________________</td>
            <td>
              <b style="font-size: 14px">Copies to be sent to Jettainer</b>
            </td>
          </tr>
        </table>
      </div>
      <!-- <template v-slot:customFooter>
        <div class="text-left">
          <p>
            I hereby acknowledge that I received the above-mentioned items in
            good condition.
          </p>
          <ul class="list-unstyled">
            <li>Received by:</li>
            <li>Date &amp; Time:</li>
          </ul>
        </div>
      </template> -->
    </print-template>
  </div>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import ULD from "@/models/ULD";
export default {
  name: "ULDBatchInfo",
  components: { PrintTemplate },
  data: () => ({
    isLoading: false,
    isDownloading: false,
    hideEditButton: false,
    table: { info: {}, data: [] },
    reportData: {}
  }),
  computed: {
    info() {
      if (this.table.data && this.table.data.length) {
        let item = this.table.data[0];
        return item;
      }
      return {};
    },
    shouldShowDetailedColumns() {
      return (
        this.table &&
        this.table.info &&
        Number(this.table.info.customer_id) === 6
      );
    },
    collectedReceiptNumbers() {
      if (
        !this.table ||
        !this.table.info ||
        Number(this.table.info.customer_id) !== 6 ||
        !Array.isArray(this.table.data)
      ) {
        return "";
      }
      const numbers = this.table.data
        .map(item => {
          if (!item || !item.collected_receipt_no) return "";
          return String(item.collected_receipt_no).trim();
        })
        .filter(Boolean);
      const uniqueNumbers = [...new Set(numbers)].sort((a, b) => {
        const numA = Number(a);
        const numB = Number(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.localeCompare(b);
      });
      return uniqueNumbers.join(", ");
    }
  },
  methods: {
    async downloadPdf() {
      const templateRef =
        this.$refs.standardPrintTemplate || this.$refs.jettainerPrintTemplate;
      if (!templateRef || !templateRef.sendPdf) return;
      this.isDownloading = true;
      const shouldHideEditButton =
        this.table &&
        this.table.info &&
        !this.table.info.is_jettainer &&
        !this.hideEditButton;
      if (shouldHideEditButton) {
        this.hideEditButton = true;
        await this.$nextTick();
      }
      try {
        await templateRef.sendPdf();
      } finally {
        if (shouldHideEditButton) {
          this.hideEditButton = false;
          await this.$nextTick();
        }
        this.isDownloading = false;
      }
    }
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.isLoading = true;
      ULD.get_uld_out({ batch_id: this.$route.params.id, limit: 9999 }).then(
        resp => {
          this.table = resp;
          this.isLoading = false;
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper-jettainer .form-head {
  min-height: 900px;
}
.form-head {
  min-height: 650px;
}
@media print {
  .form-head {
    min-height: 650px;
    h3 {
      margin-top: 0;
    }
  }
  .form-wrapper-jettainer .form-head {
    min-height: 860px;
  }
}

::v-deep {
  @media print {
    .jettainer-print {
      .footer-space {
        height: 0 !important;
      }
      .header-space {
        height: 50px !important;
      }
    }
    // .footer-space {
    //   height: 80px !important;
    // }
  }
}

.detailed-table {
  border: 1px solid #333;
  border-collapse: collapse;
}
.detailed-table th,
.detailed-table td {
  border: 1px solid #333;
}

.header-info-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 12px;
}
.header-info-table td {
  padding: 8px 12px;
  vertical-align: top;
}
.header-info-left > div,
.header-info-right > div {
  margin-bottom: 4px;
}
.header-info-label {
  font-weight: 600;
  margin-right: 6px;
}
.header-info-left {
  border: 1px solid #333;
}
.header-info-right {
  border: none;
}
</style>
